import Cookies from 'js-cookie';
import { BREAKPOINT_MEDIA_QUERIES } from '../../utils/breakpoints';
import { defineModule } from '../../utils/helpers';
import { toggleModal } from '.';

const getElements = () => ({
  modalPopupElements: document.querySelectorAll<HTMLElement>(
    '[data-popup-id]:not([data-popup-notification-bar])',
  ),
  notificationBarElements: document.querySelectorAll<HTMLElement>(
    '[data-popup-notification-bar]',
  ),
});

const checkPopups = () => {
  const { modalPopupElements } = getElements();

  return [...modalPopupElements].some((popup) => {
    const { popupId } = popup.dataset;

    if (!Cookies.get(`popup-${popupId}`)) {
      popup.classList.remove('!hidden');
      toggleModal('popup', true);
      return true;
    }

    return false;
  });
};

const checkNotificationBars = () => {
  const { notificationBarElements } = getElements();

  notificationBarElements.forEach((bar) => {
    const { popupId } = bar.dataset;

    if (!Cookies.get(`popup-${popupId}`)) {
      bar.classList.remove('!hidden');
    }
  });
};

const dismissPopup = ({ currentTarget }: Event) => {
  if (!(currentTarget instanceof HTMLElement)) return;

  const popup = currentTarget.closest<HTMLElement>('[data-popup-id]');
  if (!popup) return;

  const { popupId, popupGlobal } = popup.dataset;

  popup.classList.add('!hidden');
  Cookies.set(`popup-${popupId}`, 'dismissed', {
    expires: 1,
    path: popupGlobal !== undefined ? '/' : undefined,
  });

  toggleModal('popup', false);

  checkPopups();
};

const dismissNotificationBar = ({ currentTarget }: Event) => {
  if (!(currentTarget instanceof HTMLElement)) return;

  const bar = currentTarget.closest<HTMLElement>(
    '[data-popup-notification-bar]',
  );
  if (!bar) return;

  const { popupId, popupGlobal } = bar.dataset;

  const isMobile = !BREAKPOINT_MEDIA_QUERIES.md.matches;

  if (isMobile) {
    bar.classList.add('translate-y-full');
  } else {
    bar.style.marginTop = `-${bar.offsetHeight}px`;
    bar.classList.add('-translate-y-full');
  }
  bar.addEventListener(
    'transitionend',
    () => {
      bar.classList.add('!hidden');
    },
    { once: true },
  );

  Cookies.set(`popup-${popupId}`, 'dismissed', {
    expires: 1,
    path: popupGlobal !== undefined ? '/' : undefined,
  });
};

export default defineModule(
  () => {
    const { modalPopupElements, notificationBarElements } = getElements();

    modalPopupElements.forEach((popupEl) => {
      popupEl
        ?.querySelectorAll<HTMLElement>('[data-dismiss-modal], .cta_button')
        .forEach((element) => {
          element.addEventListener('click', dismissPopup);
        });
    });

    notificationBarElements.forEach((barEl) => {
      barEl
        ?.querySelectorAll<HTMLElement>(
          '[data-dismiss-notification-bar], .cta_button',
        )
        .forEach((element) => {
          element.addEventListener('click', dismissNotificationBar);
        });
    });

    checkPopups();
    checkNotificationBars();
  },
  () => {
    const { modalPopupElements, notificationBarElements } = getElements();

    modalPopupElements.forEach((popupEl) => {
      popupEl
        ?.querySelectorAll<HTMLElement>('[data-dismiss-modal], .cta_button')
        .forEach((element) => {
          element.removeEventListener('click', dismissPopup);
        });
    });

    notificationBarElements.forEach((barEl) => {
      barEl
        ?.querySelectorAll<HTMLElement>(
          '[data-dismiss-notification-bar], .cta_button',
        )
        .forEach((element) => {
          element.removeEventListener('click', dismissNotificationBar);
        });
    });

    toggleModal('popup', false);
  },
);
